export default "__VITE_ASSET__CW39m0AM__"